import { useContext } from "react";

import { alpha, Box, Divider, IconButton, Typography, useTheme } from "@mui/material";
import { ColorModeContext } from "../../providers/Theme";
import logo from "../../assets/logo.png";
import logoLight from "../../assets/logo-pos.png";
import { DialogVersion } from "../Dashboard/DialogVersion";
import pj from "../../../package.json";
import { environments } from "../../environments";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import TableComponent from "./Table";
import LoadingPage from "../LoadingPage";

import { useCheckPermissaoSegura } from "../../hooks/useCheckPermissaoSegura";
import { useMunicipioFromUrl } from "../../hooks/useMunicipioFromUrl";
import AuditoriaTabs from "../../components/AuditoriaTabs";

export default function AuditoriaUsuarios() {
  const autorizado = useCheckPermissaoSegura(true);
  const theme = useTheme();
  const color = useContext(ColorModeContext);
  useMunicipioFromUrl();

  if (!autorizado) return <LoadingPage message="Verificando permissões de acesso" />;

  return (
    <>
      <Box
        sx={{
          width: "95vw",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          id="logo-container"
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            width: "100%",
            marginTop: theme.spacing(1),
            marginLeft: theme.spacing(2),
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
              }}
            >
              <img className="logo-dashboard" src={theme.palette.mode === "dark" ? logo : logoLight} alt="logo" />

              <Divider
                sx={{
                  marginRight: theme.spacing(1),
                  marginLeft: theme.spacing(1),
                }}
                orientation="vertical"
                flexItem
              />

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <Typography
                  variant="caption"
                  fontWeight={"700"}
                  sx={{
                    color: alpha(theme.palette.text.secondary, 0.4),
                  }}
                >
                  Caracterização
                </Typography>

                <DialogVersion>
                  {pj.version} - {environments.ambiente}
                </DialogVersion>
              </Box>
            </Box>

            <Box id="dark-mode-toggle" sx={{ display: "flex", gap: theme.spacing(1) }}>
              <IconButton onClick={color.toggleColorMode} color="inherit">
                {theme.palette.mode === "dark" ? <Brightness7Icon /> : <DarkModeIcon />}
              </IconButton>
            </Box>
          </Box>
        </Box>
      </Box>

      <AuditoriaTabs />

      <Box sx={{ marginTop: 6 }}>
        <TableComponent />
      </Box>
    </>
  );
}
